import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { 
  PoButtonModule, 
  PoContainerModule, 
  PoProgressModule, 
  PoPageModule,
  PoInfoModule,
  PoIconModule,
  PoTagModule,
  PoModalComponent,
  PoModalModule,
  PoModalAction,
  PoFieldModule
} from '@po-ui/ng-components';
import { StepBreadcrumbComponent, StepBreadcrumbItem } from '../../../shared/components/step-breadcrumb/step-breadcrumb.component';
import { ScannerComponent } from '../../../shared/components/scanner/scanner.component';
import { ConferenceItem } from './conference-item.interface';
import { EmbarqueService } from '../../../shared/service/embarque.service';
import { TokenService } from '../../../shared/service/token.service';
import { AudioService } from '../../../shared/service/audio.service';
import { ToasterComponent } from '../../../shared/components/toaster/toaster.component';
import { ToasterService } from '../../../shared/service/toaster.service';
import { PoTagType } from '@po-ui/ng-components';

@Component({
  selector: 'app-departure-conference',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    PoButtonModule,
    PoContainerModule,
    PoProgressModule,
    PoPageModule,
    PoInfoModule,
    PoIconModule,
    PoTagModule,
    PoModalModule,
    PoFieldModule,
    ScannerComponent,
    StepBreadcrumbComponent,
    ToasterComponent
  ],
  templateUrl: './departure-conference.component.html',
  styleUrl: './departure-conference.component.css'
})
export class DepartureConferenceComponent implements OnInit {
  @Input() queryParamsInput: any;
  // Audio beep codes
  private readonly BEEP_SUCCESS = 3;
  private readonly BEEP_WARNING = 4;
  private readonly BEEP_ERROR = 5;

  // Conference status codes
  private readonly STATUS_CHECKED = 1;
  private readonly STATUS_PENDING = 2;
  private readonly STATUS_IN_CONFERENCE = 3;
  private readonly STATUS_DIVERGENT = 4;

  // Timing constants
  private readonly INPUT_FOCUS_DELAY = 100;
  private readonly COUNT_INITIALIZATION_DELAY = 1000;

  // Default values
  private readonly DEFAULT_PRODUCT_QUANTITY = 1;
  private readonly DEFAULT_PAGE_NUMBER = 1;
  private readonly DEFAULT_PAGE_SIZE = 100;

  branchCode: number = 0;
  invoiceSequence: number = 0;
  invoiceDate: string = '';
  invoiceCode: number = 0;
  serialCode: number = 0;
  issueDate: string = '';
  personCode: number = 0;
  personName: string = '';
  accessKey: string = '';
  orderBranchCode: number = 0;
  orderCode: number = 0;
  conferenceStatus: string = '';
  countCode: number = 0;
  expectedItems: number = 0;
  conferredItems: number = 0;
  listItemsConference: any[] = [];
  lastBatchBarCode: string = '';
  productQuantity: number = this.DEFAULT_PRODUCT_QUANTITY;

  getItemStatusValue(conferred: number, expected: number): string {
    if (conferred === 0) return 'Aguardando Conferência';
    if (conferred >= expected) return 'Conferido';
    return 'Em Conferência';
  }

  getItemStatusType(conferred: number, expected: number): PoTagType {
    if (conferred === 0) return 'info' as PoTagType;
    if (conferred >= expected) return 'success' as PoTagType;
    return 'warning' as PoTagType;
  }
  progress: number = 0;
  get missingItems(): number {
    return Math.max(0, this.expectedItems - this.conferredItems);
  }
  isShowingConferred: boolean = false;
  activeStatusFilter: 'waiting' | 'inProgress' | 'completed' = 'waiting';
  
  conferenceDescription: string = '';
  pendingStatusValue: number | undefined = undefined;
  
  @ViewChild(ScannerComponent) scannerComponent!: ScannerComponent;
  @ViewChild(ToasterComponent) toasterComponent!: ToasterComponent;
  @ViewChild('modalConferenceDescription') modalConferenceDescription!: PoModalComponent;
  
  modalPrimaryAction: PoModalAction = {
    action: () => this.confirmCreateConference(),
    label: 'Confirmar'
  };

  modalSecondaryAction: PoModalAction = {
    action: () => this.cancelCreateConference(),
    label: 'Cancelar'
  };
  
  private allItems: ConferenceItem[] = [];
  private hasReached100Percent: boolean = false;
  isScannerVisible: boolean = true;
  private apiCallSequence: number = 0;

  readonly breadcrumbs: StepBreadcrumbItem[] = [
    { label: 'Home', id: '/home' },
    { label: 'Conferência de Embarque', id: '/embarque' },
    { label: 'Conferência', id: '' }
  ];

  orderCountStep = 2;

  get itemsAguardando(): ConferenceItem[] {
    return this.allItems.filter(item => item.conferred === 0 && item.expected > 0);
  }

  get itemsEmConferencia(): ConferenceItem[] {
    return this.allItems.filter(item => item.conferred > 0 && item.conferred < item.expected && item.expected > 0);
  }

  get itemsConferidos(): ConferenceItem[] {
    return this.allItems.filter(item => item.conferred >= item.expected && item.expected > 0);
  }

  get currentItems(): ConferenceItem[] {
    switch (this.activeStatusFilter) {
      case 'waiting':
        return this.itemsAguardando;
      case 'inProgress':
        return this.itemsEmConferencia;
      case 'completed':
        return this.itemsConferidos;
      default:
        return [];
    }
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private embarqueService: EmbarqueService,
    private toasterService: ToasterService,
    private tokenService: TokenService,
    private audioService: AudioService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const sourceParams = this.queryParamsInput || params;
      
      this.branchCode = Number(sourceParams['branchCode']);
      this.invoiceSequence = Number(sourceParams['invoiceSequence']);
      this.invoiceDate = sourceParams['invoiceDate'] || '';
      this.invoiceCode = Number(sourceParams['invoiceCode']);
      this.serialCode = Number(sourceParams['serialCode']);
      this.issueDate = sourceParams['issueDate'] || '';
      this.personCode = Number(sourceParams['personCode']) || sourceParams['orderNumber'] || '';
      this.personName = sourceParams['personName'] || '';
      this.accessKey = sourceParams['accessKey'] || '';
      this.orderBranchCode = Number(sourceParams['orderBranchCode']) || 0;
      this.orderCode = Number(sourceParams['orderCode']) || 0;
      this.conferenceStatus = sourceParams['conferenceStatus'] || '';
      
      this.checkExistingBoardingConference();
      
    });
  }

  private loadInitialBoardingConferenceItems(): void {
    const formattedDate = this.formatDate(this.invoiceDate);
    
    if (this.allItems.length === 0) {
      return;
    }
    
    this.embarqueService.getBoardingConferenceItems(
      this.branchCode,
      this.invoiceSequence,
      formattedDate
    ).subscribe({
      next: (response: any) => {
        if (response?.items) {
          this.updateItemsFromBoardingResponse(response.items);
          this.recalculateTotals();
        }
      },
      error: (error) => {
        this.handleError(error, 'Erro ao carregar itens da boarding conference.');
      }
    });
  }

  private loadInvoiceItems(): void {
    const formattedDate = this.formatDate(this.invoiceDate);
    
    this.embarqueService.getInvoiceItems(
      this.branchCode,
      this.invoiceSequence,
      formattedDate
    ).subscribe({
      next: (response: any) => {
        this.listItemsConference = response.items || [];
        if (response?.items) {
          this.mapInvoiceItems(response.items);
          this.loadLocationsForItems();
          this.loadInitialBoardingConferenceItems();
        }
      },
      error: (error) => {
        this.handleError(error, 'Erro ao carregar itens de conferência.');
      }
    });
  }

  private mapInvoiceItems(items: any[]): void {
    this.allItems = items.map((item: any) => {
      const mapped = {
        number: item.productCode?.toString() || '',
        description: item.productName || item.productDescription || '',
        expected: item.quantity || 0,
        conferred: 0,
        batchBarCode: item.batchBarCode || '',
        batchCode: item.batchCode !== undefined ? item.batchCode : undefined,
        branchCode: item.branchCode || 0,
        invoiceDate: item.invoiceDate || '',
        invoiceSequence: item.invoiceSequence || 0,
        measureUnit: item.measureUnit || '',
        productCode: item.productCode || 0,
        productDescription: item.productDescription || '',
        quantity: item.quantity || 0,
        location: (() => {
          const hasLocation = item.locationCode && String(item.locationCode).trim();
          const hasLastLocation = item.lastLocationCode && String(item.lastLocationCode).trim();
          if (hasLocation) {
            return String(item.locationCode) + (item.locationDescription ? ' - ' + item.locationDescription : '');
          }
          if (hasLastLocation) {
            return String(item.lastLocationCode) + (item.lastLocationDescription ? ' - ' + item.lastLocationDescription : '');
          }
          return '';
        })(),
        locationIsLast: (!(item.locationCode && String(item.locationCode).trim()) && (item.lastLocationCode && String(item.lastLocationCode).trim())) || false
      };
      return mapped;
    });
    
    this.expectedItems = this.allItems.reduce((total, item) => total + item.expected, 0);
    this.conferredItems = 0;
    this.calculateProgress();
  }

  private loadLocationsForItems(): void {
    if (!this.allItems || this.allItems.length === 0) return;

    const batchCodes = Array.from(new Set(this.allItems
      .filter(i => i.batchCode !== undefined && i.batchCode !== null)
      .map(i => i.batchCode as number)));

    const batchBarCodes = Array.from(new Set(this.allItems
      .filter(i => (!i.batchCode || i.batchCode === null) && i.batchBarCode && String(i.batchBarCode).trim())
      .map(i => i.batchBarCode)));

    batchCodes.forEach(code => {
      this.embarqueService.getBatchItemByCode(this.branchCode, Number(code)).subscribe({
        next: (res: any) => {
          const apiItem = res?.items?.[0];
          if (!apiItem) return;

          const hasLocation = apiItem.locationCode && String(apiItem.locationCode).trim();
          const hasLastLocation = apiItem.lastLocationCode && String(apiItem.lastLocationCode).trim();
          const locationStr = hasLocation
            ? String(apiItem.locationCode) + (apiItem.locationDescription ? ' - ' + apiItem.locationDescription : '')
            : (hasLastLocation ? String(apiItem.lastLocationCode) + (apiItem.lastLocationDescription ? ' - ' + apiItem.lastLocationDescription : '') : '');

          this.allItems.forEach(it => {
            if (it.batchCode === code) {
              it.location = locationStr;
              it.locationIsLast = !hasLocation && !!hasLastLocation;
            }
          });
        },
        error: (err: any) => { console.error('Erro getBatchItemByCode for batchCode=', code, err); }
      });
    });

    batchBarCodes.forEach(bar => {
      this.embarqueService.getBatchItemByBarCode(this.branchCode, String(bar)).subscribe({
        next: (res: any) => {
          const apiItem = res?.items?.[0];
          if (!apiItem) return;

          const hasLocation = apiItem.locationCode && String(apiItem.locationCode).trim();
          const hasLastLocation = apiItem.lastLocationCode && String(apiItem.lastLocationCode).trim();
          const locationStr = hasLocation
            ? String(apiItem.locationCode) + (apiItem.locationDescription ? ' - ' + apiItem.locationDescription : '')
            : (hasLastLocation ? String(apiItem.lastLocationCode) + (apiItem.lastLocationDescription ? ' - ' + apiItem.lastLocationDescription : '') : '');

          this.allItems.forEach(it => {
            if (it.batchBarCode === bar) {
              it.location = locationStr;
              it.locationIsLast = !hasLocation && !!hasLastLocation;
            }
          });
        },
        error: (err: any) => { console.error('Erro getBatchItemByBarCode for batchBarCode=', bar, err); }
      });
    });
  }

  private checkExistingBoardingConference(): void {
    const statusMap: { [key: string]: number } = {
      'Checked': this.STATUS_CHECKED,
      'Pending': this.STATUS_PENDING,
      'InConference': this.STATUS_IN_CONFERENCE,
      'Divergent': this.STATUS_DIVERGENT
    };

    const statusValue = this.conferenceStatus ? statusMap[this.conferenceStatus] : undefined;

    this.embarqueService.getBoardingConference(
      this.branchCode,
      this.invoiceSequence,
      this.invoiceDate,
      this.invoiceDate,
      statusValue
    ).subscribe({
      next: (response) => {
        if (response.items && response.items.length > 0) {
          this.countCode = response.items[response.items.length - 1].countCode || 0;
          this.loadInvoiceItems();
        } else {
          this.checkAnyExistingBoardingConference(statusValue);
        }
      },
      error: (error) => {
        this.toasterService.triggerAlert(error?.error?.[0]?.message || 'Erro ao verificar conferência.', 'error');
      }
    });
  }

  private checkAnyExistingBoardingConference(statusValue: number | undefined): void {
    this.embarqueService.getBoardingConference(
      this.branchCode,
      this.invoiceSequence,
      this.invoiceDate,
      this.invoiceDate,
      undefined
    ).subscribe({
      next: (response) => {
        if (response.items && response.items.length > 0) {
          this.countCode = response.items[response.items.length - 1].countCode || 0;
          this.loadInvoiceItems();
        } else {
          this.initializeCount(statusValue);
          this.loadInvoiceItems();
        }
      },
      error: (error) => {
        this.initializeCount(statusValue);
        this.loadInvoiceItems();
      }
    });
  }

  private initializeCount(statusValue: number | undefined): void {
    const timestamp = new Date().toLocaleDateString('pt-BR', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric'
    });
    this.conferenceDescription = `Conferência NF ${this.invoiceCode}-${this.serialCode} - ${timestamp}`;
    this.pendingStatusValue = statusValue;
    this.modalConferenceDescription.open();
  }

  confirmCreateConference(): void {
    if (!this.conferenceDescription || this.conferenceDescription.trim() === '') {
      this.toasterService.triggerAlert('A descrição da conferência é obrigatória', 'warning');
      return;
    }

    this.modalConferenceDescription.close();
    const componentCode = this.tokenService.getComponentCode('embarque')!;
    
    setTimeout(() => {
      this.embarqueService.postCount(
        this.branchCode,  
        this.conferenceDescription,
        componentCode
      ).subscribe({
        next: (response: { code: number; items?: Array<{ productCode: number; quantity: number }> }) => {
          this.countCode = response.code;
          const userCode = this.tokenService.getUserCode();
          this.embarqueService.postBoardingConferenceHeader(
            this.branchCode,       
            response.code,         
            this.branchCode,      
            this.invoiceSequence,
            this.pendingStatusValue,
            this.orderCode,
            this.orderBranchCode,
            this.invoiceDate,
            userCode || undefined
          ).subscribe({
            next: (headerResponse) => {
              this.updateBoardingConferenceStatusSilent('InConference');
            },
            error: (headerError) => {
              this.toasterService.triggerAlert(headerError?.error?.[0]?.message || 'Erro ao criar header da conferência.', 'error');
            }
          });
        },
        error: (error) => {
          this.handleError(error, 'Erro ao criar contagem.');
        }
      });
    }, this.COUNT_INITIALIZATION_DELAY);
  }

  cancelCreateConference(): void {
    this.conferenceDescription = '';
    this.pendingStatusValue = undefined;
    this.modalConferenceDescription.close();
    this.router.navigate(['/embarque']);
  }

  onScannedData(barcode: string): void {
    if (this.isAllItemsConferred()) {
      this.showAllItemsConferredWarning();
      return;
    }

    let countItem = this.allItems.find(c => c.batchBarCode && c.batchBarCode === barcode.toString());
    
    if (!countItem) {
      countItem = this.allItems.find(c => c.number === barcode.toString());
    }

    if (countItem && countItem.conferred >= countItem.expected) {
      this.showItemAlreadyConferredWarning();
      return;
    }

    this.fetchBatchBarCodeAndProcess(barcode);
  }

  private isAllItemsConferred(): boolean {
    return this.conferredItems >= this.expectedItems;
  }

  private showAllItemsConferredWarning(): void {
    this.audioService.playBeep(this.BEEP_WARNING);
    this.toasterService.triggerAlert('Todos os itens já foram conferidos.', 'warning');
    this.focusScannerInput();
  }

  private fetchBatchBarCodeAndProcess(barcode: string): void {
    const formattedDate = this.formatDate(this.invoiceDate);
    
    this.embarqueService.getBoardingConferenceItems(
      this.branchCode,
      this.invoiceSequence,
      formattedDate
    ).subscribe({
      next: (boardingResponse: any) => {
        this.handleBoardingResponse(boardingResponse, barcode);
      },
      error: () => {
        this.productQuantity = this.DEFAULT_PRODUCT_QUANTITY;
        this.processConferenceItem(barcode);
      }
    });
  }

  private handleBoardingResponse(boardingResponse: any, barcode: string): void {
    if (boardingResponse?.items) {
      this.embarqueService.getProduct(barcode, this.branchCode).subscribe({
        next: (productResponse: any) => {
          if (productResponse.items[0]?.isBatchItem) {
            // this.extractProductQuantity(productResponse);
            const matchedItem = this.allItems.find(c => c.batchBarCode && c.batchBarCode === barcode.toString())
              || this.allItems.find(c => c.number === barcode.toString());
            this.productQuantity = matchedItem
              ? Math.max(0, matchedItem.expected - matchedItem.conferred)
              : this.DEFAULT_PRODUCT_QUANTITY;
            this.processConferenceItem(barcode);
          } else {
            // (productResponse.items[0]?.isPack) ?
            // this.processConferenceItem(barcode) :
            // this.processConferenceItem(productResponse.items[0]?.productCode);
            if (productResponse.items[0]?.isPack) {
              const matchedItem = this.allItems.find(c => c.batchBarCode && c.batchBarCode === barcode.toString())
                || this.allItems.find(c => c.number === barcode.toString());
              this.productQuantity = matchedItem
                ? Math.max(0, matchedItem.expected - matchedItem.conferred)
                : this.DEFAULT_PRODUCT_QUANTITY;
              this.processConferenceItem(barcode);
            } else {
              this.processConferenceItem(productResponse.items[0]?.productCode);
            }
          }
        },
        error: () => {
          this.showProductNotFoundError();
        }
      });
    } else {
      this.processConferenceItem(barcode);
    }
  }

  private extractProductQuantity(productResponse: any): void {
    if (productResponse?.items?.length > 0) {
      this.productQuantity = productResponse.items[0].quantity || this.DEFAULT_PRODUCT_QUANTITY;
    } else {
      this.productQuantity = this.DEFAULT_PRODUCT_QUANTITY;
    }
  }

  private processConferenceItem(barcode: any): void {
    let countItem = this.allItems.find(c => c.batchBarCode && c.batchBarCode === barcode.toString());
    
    if (!countItem) {
      countItem = this.allItems.find(c => c.number === barcode.toString());
    }

    if (!countItem) {
      this.showProductNotFoundError();
      return;
    }

    if (countItem.conferred >= countItem.expected) {
      this.showItemAlreadyConferredWarning();
      return;
    }
    
    this.postConferenceItem(countItem.productCode, countItem, barcode.toString());
  }

  private showProductNotFoundError(): void {
    this.audioService.playBeep(this.BEEP_ERROR);
    this.toasterService.triggerAlert('Produto não encontrado na nota fiscal.', 'error');
    this.focusScannerInput();
  }

  private showItemAlreadyConferredWarning(): void {
    this.audioService.playBeep(this.BEEP_WARNING);
    this.toasterService.triggerAlert('Este item já foi conferido completamente.', 'warning');
    this.focusScannerInput();
  }

  private postConferenceItem(productCode: any, countItem: ConferenceItem, scannedBarcode: string): void {
    this.embarqueService.postConferenceCountItem(
      this.branchCode,
      this.countCode,
      productCode,
      scannedBarcode,
      this.productQuantity
    ).subscribe({
      next: (response) => {
        this.updateConferredQuantities(countItem);
        this.playSuccessBeep();
        this.productQuantity = this.DEFAULT_PRODUCT_QUANTITY;
        this.focusScannerInput();
      },
      error: (error) => {
        this.handleError(error, 'Erro ao conferir item.');
        this.audioService.playBeep(this.BEEP_ERROR);
        this.productQuantity = this.DEFAULT_PRODUCT_QUANTITY;
        this.focusScannerInput();
      }
    });
  }

  private updateConferredQuantities(countItem: ConferenceItem): void {
    const previousConferred = countItem.conferred;
    const newConferred = Math.min(countItem.conferred + this.productQuantity, countItem.expected);
    const actualIncrease = newConferred - previousConferred;
    
    countItem.conferred = newConferred;
    this.conferredItems += actualIncrease;
    
    this.calculateProgress();
    
    if (this.progress >= 100 && !this.hasReached100Percent) {
      this.hasReached100Percent = true;
      this.isScannerVisible = false;
      this.updateBoardingConferenceStatus('Checked');
    }
  }

  private playSuccessBeep(): void {
    this.audioService.playBeep(this.BEEP_SUCCESS);
  }

  private formatDate(date: string): string {
    return date ? new Date(date).toISOString().split('T')[0] : '';
  }

  private updateItemsFromBoardingResponse(items: any[]): void {
    this.allItems.forEach(item => {
      item.conferred = 0;
    });

    const conferredMap = new Map<string, number>();
    
    items.forEach((apiItem: any) => {
      const productCode = apiItem.productCode?.toString();
      const batchBarCode = apiItem.batchBarCode || '';
      const key = `${productCode}_${batchBarCode}`;
      const current = conferredMap.get(key) || 0;
      conferredMap.set(key, current + (apiItem.countQuantity || 0));
    });
    
    conferredMap.forEach((totalCountQuantity, key) => {
      const [productCode, batchBarCode] = key.split('_');
      
      let existingItem = this.allItems.find(item => 
        item.number === productCode && 
        item.batchBarCode === batchBarCode
      );
      
      if (!existingItem && !batchBarCode) {
        existingItem = this.allItems.find(item => 
          item.number === productCode && 
          !item.batchBarCode
        );
      }
      
      if (existingItem) {
        const limitedConferred = Math.min(totalCountQuantity, existingItem.expected);
        existingItem.conferred = limitedConferred;
        
        if (batchBarCode && !existingItem.batchBarCode) {
          existingItem.batchBarCode = batchBarCode;
        }
      }
    });
  }

  private recalculateTotals(): void {
    this.expectedItems = this.allItems.reduce((total, item) => total + item.expected, 0);
    this.conferredItems = this.allItems.reduce((total, item) => total + item.conferred, 0);
    this.calculateProgress();
    
    if (this.progress >= 100) {
      this.hasReached100Percent = true;
      this.isScannerVisible = false;
    }
  }

  private handleError(error: any, defaultMessage: string): void {
    this.toasterService.triggerAlert(error?.error?.[0]?.message || defaultMessage, 'error');
  }

  private calculateProgress(): void {
    if (this.expectedItems <= 0) {
      this.progress = 0;
      return;
    }
    
    if (this.conferredItems > this.expectedItems) {
      this.conferredItems = this.expectedItems;
    }
    
    this.progress = Math.min(100, Math.round((this.conferredItems / this.expectedItems) * 100));
  }

  private updateBoardingConferenceStatus(status: string): void {
    const formattedDate = this.formatDate(this.invoiceDate);
    
    this.embarqueService.postBoardingConferenceStatus(
      this.branchCode,
      this.countCode,
      this.branchCode,
      this.invoiceSequence,
      formattedDate,
      status
    ).subscribe({
      next: (response) => {
        if (status !== 'inConference') {
          this.toasterService.triggerAlert(
            'Conferência concluída com sucesso!',
            'success'
          );
        }
        setTimeout(() => {
          this.router.navigate(['/embarque']);
        }, 1000);
      },
      error: (error) => {
        this.toasterService.triggerAlert(
          error?.error?.[0]?.message || 'Erro ao atualizar status da conferência.',
          'error'
        );
      }
    });
  }

  private updateBoardingConferenceStatusSilent(status: string): void {
    const formattedDate = this.formatDate(this.invoiceDate);
    
    this.embarqueService.postBoardingConferenceStatus(
      this.branchCode,
      this.countCode,
      this.branchCode,
      this.invoiceSequence,
      formattedDate,
      status
    ).subscribe({
      next: (response) => {
      }
    });
  }

  setStatusFilter(status: 'waiting' | 'inProgress' | 'completed'): void {
    this.activeStatusFilter = status;
    this.focusScannerInput();
  }

  private focusScannerInput(): void {
    setTimeout(() => {
      const inputElement = document.querySelector('input[name="inputBarcode"]') as HTMLInputElement;
      if (inputElement) {
        inputElement.focus();
      }
    }, this.INPUT_FOCUS_DELAY);
  }

  navigateBreadcrumb(event: { item: StepBreadcrumbItem; index: number }): void {
    if (event.item.id) {
      this.router.navigate([event.item.id]);
    }
  }
}
